export default __webpack_public_path__ + "static/media/Sora_Harukawa_Anime_Chibi.8bf0a049.png";